import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  disabled: boolean
}>

export default function PostHogNativeProvider({ children }: Props) {
  return <>{children}</>
}
